import React, { Fragment, useEffect, useState } from 'react';
import {css, Global, keyframes} from '@emotion/react';
import {BrowserRouter as Router, Switch, Route, Redirect, useHistory, Link, useParams} from 'react-router-dom';

import api from '../api';
import config from '../config';
import {Title} from '../components/common';
import {BtnBorder} from '../components/buttons';

import BtnYES from 'url:../images/btn-yes.svg';
import BtnNO from 'url:../images/btn-no.svg';
import BtnYESGray from 'url:../images/btn-yes-gray.svg';
import BtnNOGray from 'url:../images/btn-no-gray.svg';
import BorderImage from 'url:../images/border.svg';

export const MeasurementTest = ({subject, confirmation_test_answers, pictures, onFinish}) => {
  const history = useHistory();
  const {subject_number} = useParams();
  const [answers, setAnswers] = useState([]);
  const [sendError, setSendError] = useState(false);
  const [authError, setAuthError] = useState(false);
  const [panic, setPanic] = useState(null);
  const setAnswer = (val, i) => {
    const a = answers.map((v, _) => {
      return v;
    });
    a[i] = val;
    setAnswers(a);
  };
  const finish = () => {
    let collect = 0;
    answers.map((answer, i) => {
      if ( subject.measurement_test[i].answer == answer ) {
        collect++;
      }
    })
    let confirm_collect = 0;
    confirmation_test_answers.map((answer, i) => {
      if ( subject.confirmation_test[i].answer == answer ) {
        confirm_collect++;
      }
    })
    api.patch('/attend/'+subject_number+'/end', {
      confirmation_test_corrects: confirm_collect,
      measurement_test_corrects: collect,
      // pictures: pictures
    }).then((res) => {
      onFinish(answers);
      setSendError(false);
    }).catch(error => {
      if ( error.code == 401 ) {
        setAuthError(true);
      } else {
        setSendError(true);
      }
    });
  };

  if ( panic ) throw panic;
  if ( authError ) {
    return (
      <div css={css`margin: 0 0 80px;`}>
        <div css={css`margin: 0 0 60px;`}>
          <Title name="データの送信に失敗しました"/>
          <p css={css`margin-top: 30px; text-align: center;`}>
            二重ログインが検出されたため、受講が無効となりました。<br/>
            再受講してください。
          </p>
        </div>
        <div css={css`display: flex; justify-content: center;`}>
          <BtnBorder name="ホームに戻る" action={() => history.push('/')}/>
        </div>
      </div>
    );
  }
  if ( sendError ) {
    return (
      <div css={css`margin: 0 0 80px;`}>
        <div css={css`margin: 0 0 60px;`}>
          <Title name="データの送信に失敗しました"/>
          <p css={css`margin-top: 30px; text-align: center;`}>
            受講情報の送信に失敗しました。<br/>
            通信状況を確認して、下記のボタンより再送信してください。<br/>
            通信状況に問題がなく、この画面が何度も表示される場合はお問い合わせください。
          </p>
        </div>
        <div css={css`display: flex; justify-content: center; margin: 0 0 20px`}>
          <BtnBorder name="データを再送信" action={() => finish()}/>
        </div>
        <div css={css`display: flex; justify-content: center;`}>
          <BtnBorder name="ホームに戻る" action={() => history.push('/')}/>
        </div>
      </div>
    );
  }
  return (
    <div css={css`margin: 0 0 80px;`}>
      <div css={css`margin: 0 0 30px; h1 { text-align: left; }`}>
        <Title name="効果測定"/>
        <p css={css`color: #f00; font-size: 12px; margin-top: 30px`}>未回答のまま画面を閉じますと、受講されていないと判断され、最初から受講しなおしとなりますのでご注意ください</p>
      </div>
      {subject.measurement_test.map((val, i) => {
        return(
        <div key={i} css={css`margin: 0 0 30px;`}>
          <p css={css`font-size: 24px; color: #999999; margin-bottom: 2rem`}>{val.number}問目</p>
          <p>{val.question}</p>
          <div css={css`display: flex; align-items: center; justify-content: flex-end;`}>
            <span css={css`margin-right: 30px; cursor: pointer;`} onClick={() => setAnswer('yes', i)}><img src={answers[i] == 'yes' ? BtnYES : BtnYESGray}/></span>
            <span css={css`cursor: pointer;`} onClick={() => setAnswer('no', i)}><img src={answers[i] == 'no' ? BtnNO : BtnNOGray}/></span>
          </div>
          <img src={BorderImage} css={css`margin-top: 30px; max-width: 100%;`}/>
        </div>
        );
      })}
      <div css={css`display: flex; justify-content: center;`}>
        <BtnBorder disabled={answers.length == subject.measurement_test.length ? false : true} name="テストを送信" action={() => finish()}/>
      </div>
    </div>
  );
}

export const Result = ({subject, answers, checkOnly}) => {
  const history = useHistory();
  let collect = 0;
  answers.map((answer, i) => {
    if ( subject.measurement_test[i].answer == answer ) {
      collect++;
    }
  });

  return (
    <div css={css`margin: 0 0 80px;`}>
      <div css={css`margin: 0 0 60px;`}>
        <Title name="ご受講ありがとうございました！"/>
        {!checkOnly && <p css={css`margin-top: 30px; text-align: center;`}>効果測定の結果は <span css={css`font-size: 24px;`}>{collect}</span> 問正解でした</p>}
      </div>
      {!checkOnly && subject.measurement_test.map((val, i) => {
        return(
        <div key={i} css={css`margin: 0 0 30px;`}>
          <p css={css`margin-bottom: 1rem`}>{val.number}問目 正解 {val.answer == 'yes' ? '○' : '×'}　あなたの回答 {!answers[i] ? '-' : answers[i] == 'yes' ? '○' : '×'}</p>
          <p>{val.explain}</p>
        </div>
        );
      })}
      <div css={css`color: #B50D16; text-align: center; margin: 50px 0 30px;`}>
        <a href="https://docs.google.com/forms/d/1bvHv90OT7Uhzn1aYwi_wWEbHxr42-AwFOTrcUN3XphE/edit" target="_blank">質問を開始する</a>
      </div>
      <div css={css`display: flex; justify-content: center;`}>
        <BtnBorder name="ホームに戻る" action={() => history.push('/')}/>
      </div>
    </div>
  );
};
